
/// <amd-module name="VSS/FluentUiReact/Icons/initialize" />
import { initializeIcons } from "./fluentui-react-icons";

initializeIcons();

// Mark icons as initialized for the existing web platform not to initialize the icons again
(window as any).vssIconsInitialized = true;
